<template>
  <div>
    <b-container class="modal-custom-title">
      <b-row>
        <b-col md="1">
          <div class="logo-wrapper">
            <img :src="getImgUrl()" :alt="applictionTypeName">
          </div>
        </b-col>
        <b-col md="11">
          <div class="text-wrapper">
            <h1>
              <strong>Neues Gesuch erfassen</strong>
              <span> | Kontaktdaten</span>
            </h1>
            <h2>{{applictionTypeName}}</h2>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row align-h="between">
        <b-col lg="7" md="7" cols="12">
          <b-row>
            <b-col>
              <h2>{{ applicationPropertyType ? 'Eigentümer' : 'Gesuchsteller'}}</h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <application-person-select :currentUser="currentUser" :isModalEdit="isModalEdit" />
            </b-col>
            <b-col cols="3" class="rev-col">
              <div class="button-wrapper-icon" v-b-modal.modal-multi-person-contact>
                <span class="icon-add_circle_outline"></span>
                <span class="text-person">Neue Person</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h2>Technischer Kontakt</h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <application-contact-person-select :currentUser="currentUser" :isModalEdit="isModalEdit" />
            </b-col>
            <b-col cols="3" class="rev-col">
              <div class="button-wrapper-icon" v-b-modal.modal-multi-person>
                <span class="icon-add_circle_outline"></span>
                <span class="text-person">Neue Person</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>Bei Rückfragen kontaktieren Sie</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-select v-model="correspondence" placeholder="correspondences[0].id" class="mb-3">
                <b-form-select-option v-for="option in correspondences" :key="option.id" :value="option.id">{{option.name}}</b-form-select-option>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <guidance
                :applicationType="finalApplicationType"
                :communityId="finalCommunityId"
              />
              <b-button @click="onSubmit" variant="primary">Weiter</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import ApplicationPersonSelect from '@/components/application/Person/ApplicationPersonSelect.vue'
  import ApplicationContactPersonSelect from '@/components/application/Person/ApplicationContactPersonSelect.vue'
  import Guidance from '@/components/application/Intro/Guidance.vue'

  export default {
    data: () => ({
      isModalEdit: ''
    }),
    async created () {
      this.$store.commit('application/SET_MODAL_PAGE', 1)
      await this.getCorrespondences()
      this.isModalEdit = this.$route.params.modalMethod === 'bearbeiten'

      if (this.isTechnicalContact) {
        this.correspondence = this.correspondences.find(c => c.codeIntern === 'GesucheKorrespondenzKontaktperson').id
      } else {
        this.correspondence = this.correspondences.find(c => c.codeIntern === 'GesucheKorrespondenzGesuchsteller').id
      }
    },
    methods: {
      onSubmit () {
        const { draftId } = this.$route.params

        this.$router
          .push({
            name: 'uebersicht',
            params: {
              modalMethod: this.isModalEdit ? 'bearbeiten' : 'erstellen',
              tabName: 'gesuch',
              draftId
            }
          })
          .catch(() => {})
      },
      async getCorrespondences () {
        try {
          const { errors } = await this.$store.dispatch('codes/GET_CODES_BY_CODEGRUPPEN', 'Korrespondenz')

          if (errors) throw errors
        } catch (err) {
          this.hasError = true

          this.errorMessage = this.$t('formError.unknownwError')

          setTimeout(() => {
            this.hasError = false
          }, 5000)
        }
      },
      getImgUrl () {
        try {
          return require(`@/assets/img/${this.finalApplicationType}.svg`)
        } catch (e) {
          return require('@/assets/img/OV.svg')
        }
      }
    },
    computed: {
      correspondence: {
        set (value) {
          this.$store.commit('application/SET_CORRESPONDENCE', value)
        },
        get () {
          return this.$store.state.application.createApplication.correspondence
        }
      },
      ...mapState({
        finalCommunityId: state => state.application.createApplication.finalCommunityId,
        finalApplicationType: state => state.application.createApplication.finalApplicationType,
        applictionTypeName: state => state.application.createApplication.applictionTypeName,
        applicationPropertyType: state => state.application.createApplication.applicationPropertyType,
        personId: state => state.application.createApplication.formData.personId,
        personContactId: state => state.application.createApplication.formData.personContactId,
        isTechnicalContact: state => state.user.currentUser.technischerKontakt
      }),
      ...mapGetters({
        currentUser: 'user/CURRENT_USER',
        correspondences: 'codes/CODES'
      })
    },
    components: {
      ApplicationPersonSelect,
      ApplicationContactPersonSelect,
      Guidance
    }
  }
</script>

<style lang="scss">
  .custom-control-input:checked ~ .custom-control-label::before,
  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before{
    background: $green;
  }

  .resp-col{
    margin-top: 0;

    @include media-breakpoint-down(md) {
      margin-top: 1rem;
    }
  }

  .rev-col{
    margin-bottom: 0;

    @include media-breakpoint-down(md) {
      margin-bottom: 1rem;
    }
  }
</style>
